import { render, staticRenderFns } from "./NbNumberedAccordionForm.vue?vue&type=template&id=58357200&scoped=true&"
import script from "./NbNumberedAccordionForm.vue?vue&type=script&lang=js&"
export * from "./NbNumberedAccordionForm.vue?vue&type=script&lang=js&"
import style0 from "./NbNumberedAccordionForm.vue?vue&type=style&index=0&id=58357200&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58357200",
  null
  
)

export default component.exports